import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  status: number;
  message: string;
  statusCode: number;
}


export const AlertConfigApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAlertConfig: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        length?: number;
        start?: number;
      }
    >({
      query: ({ length, search, start }) => ({
        url: `${END_POINTS.getAlert}?start=${start}&length=${length}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
    getAlertConfigById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getAlertById}${id}/`,
        method: "GET",
      }),
    }),
    addAlertConfig: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addAlert,
        method: "POST",
        body,
      }),
    }),
    updateAlertConfig: builder.mutation<CommonResponseType, { body: any; id: number }>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateAlert}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    deleteAlertConfig: builder.mutation<CommonResponseType, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteAlert}${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
useAddAlertConfigMutation,
useUpdateAlertConfigMutation,
useLazyGetAlertConfigByIdQuery,
useLazyGetAlertConfigQuery,
useDeleteAlertConfigMutation
} = AlertConfigApi;
